import HelperMixin from '../../../Shared/HelperMixin.vue'
import DataService from '../../../Shared/DataService.js'
export default {
    name: 'AppHeader',
    mixins: [HelperMixin],
    async created() {

        await this.CheckLoginStatus();

        // School-name chip: localStorage is NOT reactive, so the header would
        // render before Dashboard.js fetches the school. Fetch it here and hold
        // it in reactive data so the chip updates as soon as it arrives.
        if (this.isSchoolAdmin()) {
            this.schoolName = localStorage.getItem('schoolName') || '';
            try {
                const res = await DataService.GetMySchool();
                if (res && res.data && res.data.name) {
                    this.schoolName = res.data.name;
                    localStorage.setItem('schoolName', res.data.name);
                }
            } catch (e) {
                // keep whatever was cached in localStorage
            }
        }
    },
    data() {
        return {
            Info: [],
            TempInfo: [],
            Count: 0,
            schoolName: '',
            // Live unread system-pulse count shown as a small badge on the bell.
            // Refreshed by a lightweight 60s poll against the admin inbox API.
            unreadCount: 0,
            _notifTimer: null,
        };
    },

    mounted() {
        // Kick off the unread-badge poll. Guarded: only runs while a session
        // is present (CheckLoginStatus would have logged out a guest already).
        this.RefreshUnread();
        this._notifTimer = setInterval(this.RefreshUnread, 60000); // ~60s
    },

    beforeUnmount() {
        if (this._notifTimer) {
            clearInterval(this._notifTimer);
            this._notifTimer = null;
        }
    },

    // Vue 2 lifecycle name (kept for safety if this build runs under Vue 2).
    beforeDestroy() {
        if (this._notifTimer) {
            clearInterval(this._notifTimer);
            this._notifTimer = null;
        }
    },

    methods: {

        //href(url) {
        //    this.$router.push(url);
        //},
        href(url, id) {

            if (this.$route.path === url)
                return; // Do nothing if the current URL matches the target URL

            this.$router.push(url);
            for (var i = 0; i < 20; i++) {
                if (i == id) {
                    this.$set(this.menuFlag, id, '');
                } else {
                    this.$set(this.menuFlag, i, '');
                }
            }
        },

        // Open the admin notifications INBOX page (NOT the broadcast/send page).
        goToInbox() {
            if (this.$route.path !== '/UsersNotifications') {
                this.$router.push('/UsersNotifications').catch(function () { /* duplicate nav */ });
            }
        },

        // Lightweight unread-count refresh for the bell badge. Guarded so a
        // signed-out session never fires the request, and any error (401 on a
        // dropped cookie, network blip) just leaves the badge as-is.
        async RefreshUnread() {
            if (!localStorage.getItem('currentUser-client')) {
                this.unreadCount = 0;
                return;
            }
            try {
                // pagesize=1 keeps the payload tiny — we only read statistics.active (unread).
                const res = await DataService.GetNotifications(1, 1, '');
                const stats = res && res.data ? res.data.statistics : null;
                this.unreadCount = stats && typeof stats.active === 'number' ? stats.active : 0;
            } catch (e) {
                // keep the previous badge value on transient failures
            }
        },

    }
}
